import { render, staticRenderFns } from "./policyInfoForm.vue?vue&type=template&id=2f81a25a&scoped=true"
import script from "./policyInfoForm.vue?vue&type=script&lang=js"
export * from "./policyInfoForm.vue?vue&type=script&lang=js"
import style0 from "./policyInfoForm.vue?vue&type=style&index=0&id=2f81a25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81a25a",
  null
  
)

export default component.exports